module.exports = __webpack_public_path__ + "static/media/customer_registration_header.ff197418.png";